module.exports = __webpack_public_path__ + "img/bg-popup-1.0d56c799.jpeg";